import { Location } from 'src/types/sites/sites';
export type SiteDropdownOption = {
  label: string;
  value: string;
  location: Location;
};

export enum REPORT_TEMPLATE_TYPE {
  STATUS_REPORT = 'STATUS_REPORT',
  SITE_STATUS_REPORT = 'SITE_STATUS_REPORT',
}

export const REPORT_TEMPLATE_DROPDOWN = [
  { label: 'Status Report', value: REPORT_TEMPLATE_TYPE.STATUS_REPORT },
  // { label: 'Site Status Report', value: REPORT_TEMPLATE_TYPE.SITE_STATUS_REPORT },
  // { label: 'Performance Report', value: 'Performance Report' }, <- uncomment this once performance report support is added
];

export const PDF_SITE_STATUS_TEMPLATE_DROPDOWN = [
  { label: 'Site Status Report', value: REPORT_TEMPLATE_TYPE.SITE_STATUS_REPORT },
];

export type tagListItem = {
  gatewayId: string;
  inputId: string;
  rawInputName: string;
  unit: string;
};
